<via-button-bar [showCancelModal]="true" [modalType]="modalType"></via-button-bar>
<via-progress-bar [currentStep]="2"></via-progress-bar>

<div class="e-configure-data-layout" role="main">
    <div class="e-configure-data-options">
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Frequency</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="frequencyTooltipText" *ngIf="dailyFrequencySelected"></via-info-icon>
                </div>
                <div>
                    <via-ui-frequency-dropdown [selectedFrequency]="this.configureData.frequency"
                        (frequencyChange)="updateFrequency($event)">
                    </via-ui-frequency-dropdown>
                </div>
            </div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Date range</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="dateRangeTooltipText"></via-info-icon>
                </div>
                <div>
                    <mat-form-field appearance="fill">
                        <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [min]="minDate"
                            [max]="maxDate">
                            <input readonly matStartDate formControlName="startDate" placeholder="Start date" />
                            <input (dateChange)="onDateRangeChange()" readonly matEndDate formControlName="endDate"
                                placeholder="End date" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Data type</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="dataTypeTooltipText"></via-info-icon>
                </div>
                <div class="e-data-types" (keydown)="dataTypeCheckboxKeyEvents($event)">
                    <mat-checkbox [(ngModel)]="skuPriceCheckbox" [checked]="skuPriceCheckbox"
                        (change)="updateSkuPrice()" #dataTypeCheckbox (focusin)="setFirstItemActive()">
                        Shelf SKU price (retailer sale price)
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="regularPriceCheckbox" [checked]="regularPriceCheckbox"
                        (change)="updateRegularPrice()" #dataTypeCheckbox tabindex="-1">
                        Regular/strikethrough price
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="dailySkuPromotionValueCheckBox"
                        [checked]="dailySkuPromotionValueCheckBox" (change)="updatePromotion()" #dataTypeCheckbox
                        tabindex="-1">
                        Daily SKU promotion value (actual promotion type: 2 for 3, 10% off)
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="dailyInStockCheckBox" [checked]="dailyInStockCheckBox"
                        (change)="updateDailyStock()" #dataTypeCheckbox tabindex="-1">
                        Daily in stock / Out of stock
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="ratingCheckbox" [checked]="ratingCheckbox" (change)="updateRating()"
                        #dataTypeCheckbox tabindex="-1">
                        Average star ratings
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="numberOfReviewsCheckbox" [checked]="numberOfReviewsCheckbox"
                        (change)="updateNumberOfReviews()" #dataTypeCheckbox tabindex="-1">
                        Number of ratings
                    </mat-checkbox>
                    <mat-checkbox [(ngModel)]="attributesCheckbox" [checked]="attributesCheckbox"
                        (change)="updateAttributes()" #dataTypeCheckbox tabindex="-1"
                        [disabled]="disableAttributeCheckBox">
                        Attributes
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Price point</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="pricePointTooltipText"></via-info-icon>
                </div>
                <div>
                    <mat-radio-group [disabled]="isPriceInputDisabled()" (change)="updatePricePoint($event)"
                        aria-label="Select an option">
                        <mat-radio-button *ngFor="let pricePoint of pricePointOptions" [value]="pricePoint.value"
                            [checked]="isPricePointChecked(pricePoint.value)" [disabled]="pricePoint.disabled">Price per {{ pricePoint.label }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Currency</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="currencyTooltipText"></via-info-icon>
                </div>
                <div>
                    <via-ui-currency-dropdown [selectedCurrency]="this.configureData.currency"
                        [dropdownDisabled]="isPriceInputDisabled()" (currencyChange)="updateCurrency($event)">
                    </via-ui-currency-dropdown>
                </div>
            </div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">File type</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="fileTypeTooltipText"></via-info-icon>
                </div>
                <div>
                    <mat-radio-group (change)="updateFileType($event)" aria-label="Select an option">
                        <mat-radio-button *ngFor="let fileType of fileTypes" [value]="fileType"
                            [checked]="isFileTypeChecked(fileType)">{{
                            fileType
                            }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>
    <div class="e-action-bar">
        <via-sku-count [message]="skuCountMessage +' '+ attributesMessage"></via-sku-count>
        <via-action-bar [nextButtonText]="'Save & Export'" [isNextButtonHidden]="isNextButtonHidden()"></via-action-bar>
    </div>
</div>